import React from "react";
import { Youtube, Twitch, Video, Radio, ExternalLink } from "lucide-react";

export const PLATFORMS = {
  youtube: { label: "YouTube", color: "#FF0000", Icon: Youtube },
  twitch: { label: "Twitch", color: "#9146FF", Icon: Twitch },
  kick: { label: "Kick", color: "#53FC18", Icon: Radio },
  nimotv: { label: "NimoTV", color: "#00AEEF", Icon: Video },
};

export function PlatformBadge({ platform, className = "" }) {
  const p = PLATFORMS[platform] || PLATFORMS.youtube;
  const dark = platform === "kick";
  return (
    <span data-testid={`platform-badge-${platform}`}
      className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-[11px] font-bold uppercase tracking-wide ${className}`}
      style={{ background: p.color, color: dark ? "#07090e" : "#fff" }}>
      <p.Icon size={12} /> {p.label}
    </span>
  );
}

function embedSrc(platform, key) {
  const host = typeof window !== "undefined" ? window.location.hostname : "localhost";
  if (platform === "youtube") {
    if (key.startsWith("channel:")) return `https://www.youtube.com/embed/live_stream?channel=${key.slice(8)}&autoplay=1`;
    return `https://www.youtube.com/embed/${key}?autoplay=1`;
  }
  if (platform === "twitch") return `https://player.twitch.tv/?channel=${key}&parent=${host}&autoplay=true&muted=false`;
  if (platform === "kick") return `https://player.kick.com/${key}`;
  if (platform === "nimotv" && /^\d+$/.test(key || "")) return `https://www.nimo.tv/embed/${key}`;
  return "";
}

export default function StreamEmbed({ stream }) {
  const src = embedSrc(stream.platform, stream.embed_key);
  if (!src) {
    return (
      <div className="w-full h-full grid place-items-center bg-black text-center p-6" data-testid="stream-embed-fallback">
        <div>
          <PlatformBadge platform={stream.platform} />
          <p className="mt-3 text-sm text-white/60">This platform can't be embedded here.</p>
          <a href={stream.channel_url} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-[hsl(var(--primary))]">
            Watch on {PLATFORMS[stream.platform]?.label} <ExternalLink size={14} />
          </a>
        </div>
      </div>
    );
  }
  return (
    <iframe title={stream.title} src={src} className="w-full h-full border-0" allow="autoplay; fullscreen; encrypted-media"
      allowFullScreen data-testid="stream-embed-iframe" />
  );
}
